/**
 * Auth composable - convenient wrapper around the auth store.
 */

import { computed } from "vue";
import { useAuthStore } from "@/stores/auth";
import { storeToRefs } from "pinia";

export function useAuth() {
  const store = useAuthStore();
  const {
    account,
    isAuthenticated,
    isLoading,
    error,
    requires2FA,
    requires2FASetup,
    isCustodial,
    hasConfirmedEmail,
    hasPendingEmail,
    displayName,
    accountId,
  } = storeToRefs(store);

  const accessToken = computed(() => store.getAccessToken());

  return {
    // State (reactive refs)
    account,
    isAuthenticated,
    isLoading,
    error,
    requires2FA,
    requires2FASetup,
    isCustodial,
    hasConfirmedEmail,
    hasPendingEmail,
    displayName,
    accountId,
    accessToken,

    // Actions
    loginWithWallet: store.loginWithWallet,
    loginWithOAuth: store.loginWithOAuth,
    verify2FA: store.verify2FA,
    logout: store.logout,
    initialize: store.initialize,
    getAccessToken: store.getAccessToken,
    setAccount: store.setAccount,
  };
}
